import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'antd';
import SelfServeOffers from '../SelfServeOffers';
import PlanActivationAndPayment from '../PricingModals/components/PlanActivationAndPayment/PlanActivationAndPayment';
import SuccessModal from '../../SuccessModal/SuccessModal';
import PaymentFailureModalV2 from './PaymentFailureModalV2';
import PaymentFailureModal from '../../PaymentFailureModal/PaymentFailureModal';
import PricingPlans from '../PricingModals/components/PricingPlans/PricingPlans';
import SubscriptionDetails from '../PricingModals/components/SubscriptionDetails/SubscriptionDetails';
import ENVIRONMENT from '../../../../environments';
import axios from 'axios';

const SubscriptionUpgradeManager = ({
    subscriptionUpgradeManagerModel,
    setSubscriptionUpgradeManagerModel,
    cardStatus,
    updateUserAccountInformation,
    loadUserRequestStatus,
    requestType,
    currentlyActiveSubscription,
    currentPlanPage,
    selectedPlan,

    // the following attributes are only for subscription manage modal (SubscriptionDetails)
    upgradedModal,
    upgradeSubscription,
    isAnnual,
    openPricingPlansModal,
    manageSubscriptionModal,
    closeManageSubscriptionModal,
    selectedPlanDetails,
    cancelSubscription,
    ///////////
}) => {

    const [showSelfServeOffersModal, setShowSelfServeOffersModal] = useState(currentPlanPage);
    const [selectedSubscriptionPlan, setSelectedSubscriptionPlan] = useState("ai_creator");
    const [paymentConfirmationModal, setPaymentConfirmationModal] = useState(false);
    const [quotaExceededModal, setQuotaExceededModal] = useState(!currentPlanPage);
    const [planType, setPlanType] = useState('subscription')
    const [bundleQuantity, setBundleQuantity] = useState(1)
    const [successModalVisible, setSuccessModalVisible] = useState(false)
    const [showPaymentFailureModal, setShowPaymentFailureModal] = useState(false)
    const [showSystemErrorModal, setSystemErrorModal] = useState(false)
    const [annual, setAnnual] = useState(true);
    const [subscriptionPaymentProcessing, setSubscriptionPaymentProcessing] = useState(false)
    const [partialCreditsGiven, setPartialCreditsGiven] = useState(0)
    const REQUEST_TYPE_DISPLAY_NAMES = {
        'ai_model': 'You can request your AI Models now',
        'scene_lifestyle': 'You can request your lifestyle images now',
        'variation_product_model': 'You can request your Product Variations now',
        'subscription_upgrade': 'Subscription Package is Upgraded Successfully.',
        'product_silo': 'You can request your product images now'
    }
    const [currentActiveSubscription, setCurrentActiveSubscription] = useState(null)


    useEffect(() => {
        axios.post(ENVIRONMENT.GET_UPDATE_SUBSCRIPTION_DATA, {
            "data": "subscription-plan",
            "username": localStorage.getItem('username'),
        }).then(res => {
            setCurrentActiveSubscription(res.data['name'])
        })
    }, [])



    const openPaymentConfirmationModal = (offering_plan, subscriptionType, quantity = null) => {
        console.log(offering_plan)
        console.log(subscriptionType)
        console.log(quantity)
        console.log('--------------------------------')
        setShowSelfServeOffersModal(currentPlanPage);
        setSelectedSubscriptionPlan(offering_plan);
        setPaymentConfirmationModal(true);
        setPlanType(subscriptionType)
        if (subscriptionType == 'bundle' && quantity) {
            setBundleQuantity(quantity)
        }
        setQuotaExceededModal(!currentPlanPage)
    }

    const closeSubscriptionUpgrade = () => {
        setShowSelfServeOffersModal(currentPlanPage);
        setPaymentConfirmationModal(false);
        setSubscriptionUpgradeManagerModel(false);
        setQuotaExceededModal(!currentPlanPage);

        if (selectedPlanDetails) {
            closeManageSubscriptionModal();
        }
    }

    useEffect(() => {
        console.log(currentlyActiveSubscription)
        if (currentlyActiveSubscription?.includes("annual_")) {
            setAnnual(true);
        } else {
            setAnnual(false);
        }
    }, [currentlyActiveSubscription]);

    return <>
        <PricingPlans
            currentlyActiveSubscription={currentlyActiveSubscription}
            visible={showSelfServeOffersModal && subscriptionUpgradeManagerModel}
            onClose={closeSubscriptionUpgrade}
            setAnnualSetting={setAnnual}
            openPaymentConfirmationModal={openPaymentConfirmationModal}
            selectedPlan={selectedPlan}
        />

        {selectedPlanDetails &&
            <SubscriptionDetails
                upgradedModal={upgradedModal}
                upgradeSubscription={upgradeSubscription}
                isAnnual={isAnnual}
                openPricingPlansModal={openPricingPlansModal}
                visible={manageSubscriptionModal}
                onClose={closeManageSubscriptionModal}
                data={selectedPlanDetails}
                cancelSubscription={cancelSubscription}
                openPaymentConfirmationModal={openPaymentConfirmationModal}
            />}

        <Modal
            className="plan-activation-modal"
            width={520}
            destroyOnClose
            visible={(paymentConfirmationModal && subscriptionUpgradeManagerModel) || (paymentConfirmationModal && manageSubscriptionModal)}
            closable
            onCancel={() => closeSubscriptionUpgrade()}
        >
            <PlanActivationAndPayment
                setAnnualSetting={setAnnual}
                annualSetting={annual}
                selectedPlanName={selectedSubscriptionPlan}
                signUpFlow={false}
                cardStatus={cardStatus}
                loadUserRequestStatus={loadUserRequestStatus}
                closeSubscriptionUpgrade={closeSubscriptionUpgrade}
                requestType={requestType}
                subscriptionType={planType}
                selectedBundleQuantity={bundleQuantity}
                updateUserAccountInformation={updateUserAccountInformation}
                setSuccessModalVisible={setSuccessModalVisible}
                setShowPaymentFailureModal={setShowPaymentFailureModal}
                setSystemErrorModal={setSystemErrorModal}
                setSubscriptionPaymentProcessing={setSubscriptionPaymentProcessing}
                setPartialCreditsGiven={setPartialCreditsGiven}
            />
        </Modal>

        <PaymentFailureModalV2
            paymentFailureModal={showPaymentFailureModal}
            setPaymentFailureModal={setShowPaymentFailureModal}
        />

        <PaymentFailureModal
            setPaymentFailureModal={setSystemErrorModal}
            paymentFailureModal={showSystemErrorModal}
        />

        <SuccessModal
            visible={successModalVisible}
            heading={subscriptionPaymentProcessing && partialCreditsGiven && requestType === 'subscription_upgrade' ? 'Payment Initiated' : REQUEST_TYPE_DISPLAY_NAMES[requestType]}
            text={
                subscriptionPaymentProcessing && partialCreditsGiven && requestType === 'subscription_upgrade' ? (
                    <span>
                        Payment processing initiated. We've granted you <strong>{partialCreditsGiven}%</strong> of your monthly credits to use immediately!
                        <br /><br />
                        Remaining credits unlock once payment clears. Close this window and proceed. To view details, <a href="/account-details?tab=subs" target="_blank">click here</a>.
                    </span>
                ) : (
                    <span>You can close this popup and proceed with your request. To view your subscription and usage details, <a href="/account-details?tab=subs" target="_blank">click here</a>.</span>
                )
            }
            footer={[
                <div className="justify-in-center">
                    <Button style={{ margin: "auto" }} className="modal-okay square font-14" htmlType="submit" onClick={() => {
                        setSuccessModalVisible(false)
                    }}>
                        Okay
                    </Button>
                </div>
            ]}
        />


        <Modal
            visible={subscriptionUpgradeManagerModel && quotaExceededModal}
            centered
            width={520}
            footer={null}
            closable
            onCancel={() => { setQuotaExceededModal(!currentPlanPage); setSubscriptionUpgradeManagerModel(false); }}
        >
            {currentActiveSubscription != 'custom_contract' ?
            <div style={{ marginTop: '20px' }}>
                <img
                    src="/img/exclamation-red.svg"
                    alt="Warning"
                    style={{ width: '36px', height: '36px', marginBottom: '20px' }}
                />
                <h4 className='manrope f-20 black-00' style={{ marginBottom: '20px' }}>You’re out of credits — upgrade to keep creating.</h4>
                <div className='manrope f-14 black-00' style={{ marginBottom: '24px' }}>Upgrade your plan to a subscription, or choose a one-time bundle with the credits you need.</div>
                <div className="justify-in-center" style={{ display: 'flex', gap: '8px', justifyContent: 'end' }}>
                    <Button
                        className="manrope f-14 w-500 lh-22 ai-action-btn"
                        style={{ padding: '13px 14px !important' }}
                        onClick={() => {
                            setQuotaExceededModal(false);
                            window.location.href = ('/account-details?tab=subs');
                        }}
                    >
                        See Current Plan
                    </Button>
                    <Button
                        className="manrope f-14 w-500 lh-22 ai-action-btn-blue"
                        style={{ padding: '13px 14px !important' }}
                        onClick={() => {
                            setQuotaExceededModal(false);
                            setShowSelfServeOffersModal(true);
                        }}
                    >
                        Upgrade Plan
                    </Button>
                </div>
            </div>
            : 
            <div style={{ marginTop: '20px' }}>
                <img
                    src="/img/exclamation-red.svg"
                    alt="Warning"
                    style={{ width: '36px', height: '36px', marginBottom: '20px' }}
                />
                <h4 className='manrope f-20 black-00' style={{ marginBottom: '20px' }}>You’re out of credits — buy more credits or contact sales.</h4>
                <div className="justify-in-center" style={{ display: 'flex', gap: '8px', justifyContent: 'end' }}>
                    <Button
                        className="manrope f-14 w-500 lh-22 ai-action-btn"
                        style={{ padding: '13px 14px !important' }}
                        onClick={ () => {window.location.href = ('/account-details?tab=subs&buyCreditsModal=true')}}>
                        Buy credits
                    </Button>
                    <Button
                        className="manrope f-14 w-500 lh-22 ai-action-btn-blue"
                        style={{ padding: '13px 14px !important' }}
                        onClick={() => {window.open('mailto:sales@all3d.ai', '_blank')}}>
                        Contact Sales
                    </Button>
                </div>
            </div>
            }
        </Modal>
    </>

}

export default SubscriptionUpgradeManager;